<template>
  <div class="">
    <div class="tabs">
      <ul>
        <li v-for="locale in listLocales" :key="locale.id" :class="{'is-active': localeId === locale.id}" @click.prevent="localeId = locale.id">
          <a>
            {{ locale.name }}
            <span class="icon" v-if="!localizations?.find((localization) => localization.locale_id === locale.id && localization.key === 'description')">
              <i class="fas fa-exclamation-triangle"></i>
            </span>
          </a>
        </li>
      </ul>
    </div>
    <FormField
      label="Varenavn"
    >
      <InputText
        v-model="name"
        :placeholder="form.model"
        @input="localizationChanged('name')"
      />
    </FormField>
    <FormField
        label="Beskrivelse"
    >
      <InputTextarea 
        v-model="description" 
        rows="4" 
        @input="localizationChanged('description')" 
      />
    </FormField>
    <div class="mb-2">
      <button class="button is-primary" @click="copyToWebshop">
        Kopier til webshop beskrivelse
      </button>
    </div>
    <FormField
        label="Beskrivelse til webshop"
    >
      <InputEditor
        v-model="descriptionWebshop" 
        @input="onEditorInput"
      />
    </FormField>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FormField, InputText, InputTextarea, InputEditor } from '@elems/form'

export default {
  emits: ['updated'],
  components: {
    FormField,
    InputText,
    InputTextarea,
    InputEditor,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localizations: [],
      localeId: null,
      name: '',
      description: '',
      descriptionWebshop: '',
    };
  },
  computed: {
    ...mapGetters([
      'listLocales',
    ]),
  },
  mounted() {
    this.localeId = this.listLocales[0].id;
    this.localizations = this.form.localizations;
  },
  methods: {
    onEditorInput(value) {
      this.descriptionWebshop = value;
      this.localizationChanged('descriptionWebshop');
    },
    copyToWebshop() {
      if (this.description.trim() === '') {
        return;
      }
      this.descriptionWebshop = this.description;
    },
    updateLocalizations() {
      this.updateLocalization('name');
      this.updateLocalization('description');
      this.updateLocalization('descriptionWebshop');
    },
    updateLocalization(key) {
        const localization = this.localizations.find((localization) => localization.locale_id === parseInt(this.localeId) && localization.key === key);
        this[key] = localization ? localization.value : '';
    },
    localizationChanged(key) {
      if (this[key].trim() === '' || this[key] === '<p><br></p>') {
        this.localizations = this.localizations.filter((localization) => !(localization.locale_id === parseInt(this.localeId) && localization.key === key));
      } else {
        const localization = this.localizations.find((localization) => localization.locale_id === parseInt(this.localeId) && localization.key === key);
        if (localization) {
          localization.value = this[key];
        } else {
          this.localizations.push({
            locale_id: parseInt(this.localeId),
            key: key,
            value: this[key],
          });
        }
      }

      this.$emit('updated', this.localizations);
    }
  },
  watch: {
    localeId() {
      this.updateLocalizations();
    },
  },
};
</script>

<style lang="postcss" scoped>

</style>